import StatusItem, {typesOfData} from "./StatusItem";

export class StatusItemTyresets extends StatusItem {
    constructor(dataObject) {
        super(dataObject)
        this.itemType = typesOfData.tyreSets

        // Process all tyre data.
        // possibly refactor this to its own class in future
        this.tyres = []
        dataObject.tyres.forEach(tyreData => {
            this.tyres.push({
                ...tyreData,
                result: tyreData.note.length === 0 ? "OK" : tyreData.note
            });
        })
    }
}